// @flow
import { titleToSlug } from '../../../services/titleToSlug'
import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.estrellaDammCup',
  title: 'hardCoded.title.estrellaDammCup',
  slug: titleToSlug('hardCoded.title.estrellaDammCup'),
  catalog: {
    title: 'hardCoded.catalog.title.estrellaDammCup',
    catalogMedia,
    price: numberToCurrency('15'),
    color: '#e52c11'
  }
}
